module.exports = __webpack_public_path__ + "img/tag.6aae95e9.svg";